import { render, staticRenderFns } from "./Score.vue?vue&type=template&id=53a07158&scoped=true"
import script from "./Score.vue?vue&type=script&lang=js"
export * from "./Score.vue?vue&type=script&lang=js"
import style0 from "./Score.vue?vue&type=style&index=0&id=53a07158&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "53a07158",
  null
  
)

export default component.exports